// extracted by mini-css-extract-plugin
export default {"subtitle":"AccountLedgerDialog_subtitle__Y+FjH","basis":"AccountLedgerDialog_basis__lED-f","error":"AccountLedgerDialog_error__Rj1Jq"};